import "primeflex/primeflex.css";
import "primeicons/primeicons.css";
import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { Checkbox } from "primereact/checkbox";
import { confirmDialog } from "primereact/confirmdialog";
import "primereact/resources/primereact.css";
import "primereact/resources/themes/saga-blue/theme.css";
import { useToast } from "../other/Toast";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import {
  updateCompanyRouterData,
  updateOtherRouterData,
} from "../../redux/companySlice";
import { clearRouterData, updateRouterData } from "../../redux/personSlice";
import { setBlockForm, setDcheck, setDname } from "../../redux/routerSlice";
import configureStore from "../../redux/store";
import InputText from "../other/InputText";
import KycSaveApiService from "../service/kycSaveApiService";
import {
  declerationValidation,
  validateSaveData,
  validateSubmitData,
} from "./dataValidataion";
import { PrevButton } from "./kycSidebar";
import ViewCompanyData from "./viewCompanyData";
import ViewFormData from "./viewFormData";
import { setErrorList } from "../../redux/lookupSlice";

import { useReactToPrint } from "react-to-print";
import apiService from "../service/apiService";
import { setRelativeTypeList } from "../../redux/familySlice";
import { setDocumentTypeList } from "../../redux/documentSlice";
import { englishLocales } from "validator/lib/alpha";
import DuplicateDialog from "./duplicateDialog";
import { offset } from "@popperjs/core";
import { formatAMPM } from "../../helper/helper";

function VideoKycSchedule() {

  const { t, i18n } = useTranslation();
  const [videoKycEvent, setVideoKycEvent] = useState();
  const [videoKycSlot, setVideoKycSlot] = useState();

  useEffect(() => {
    apiService.getVideoKycEvent().then((response) => {
      if (!response.data || !response.data.videoKycScheduleDto) return;
      console.log(response.data.videoKycSlotId, "response video kyc event", response.data);
      setVideoKycEvent(response.data.videoKycScheduleDto);
      setVideoKycSlot(response.data.videoKycScheduleDto.videoKycSlotList.find(s => s.id === response.data.videoKycSlotId));

    });
  }, []);

  return (
    <Card
      style={{ borderRadius: "16px" }}
      className="p-col-12 p-md-12 main-card"
      header={
        <h3 className="p-col-12 p-md-12 text-center">
          <i className="pi pi-check-square" /> {t('videoKycDetails')}
        </h3>
      }
    >
      <div className="p-field p-col-12 p-md-12 p-grid ">
        <div className="p-field p-col-12 p-md-6 p-mb-3">
          <h4 className="p-col-12 p-md-12">
            <p className="section-title p-pt-0">{t("videoKycSchedule")}</p>
          </h4>
          <div className="p-col-12 p-md-12">
            <div className="bdrTop">
              <label className="p-col-12 p-md-6 form-detail-label">
                {t("sessionDate")} :
                {videoKycSlot && (formatAMPM(new Date(videoKycSlot.startTime), false, true) + " - " + formatAMPM(new Date(videoKycSlot.endTime), false, true))}

              </label>
              <span className="p-col-12 p-md-6 form-detail-data">
              </span>
              <div style={{ clear: "both" }}></div>
            </div>
          </div>

        </div>
      </div>
    </Card>
  );
};

export default VideoKycSchedule;
